import sendUserTiming from 'js/utils/sendUserTiming';

function recordPerformanceMetrics(): void {
  if (window.performance && window.performance.measure) {
    window.performance.mark('FMP');
    window.performance.measure(
      'Time To First Meaningful Paint',
      'requestStart',
      'FMP',
    );
    sendUserTiming('Time To First Meaningful Paint');
  }

  window.addEventListener('DOMContentLoaded', function () {
    // Frontend performance instrumentation: logged out SWP
    // Metric: time to interactive
    // Accuracy: medium (w/in a frame of target)
    // Stability: medium (could change if we add more $() listeners)
    if (window.performance && window.performance.measure) {
      window.performance.mark('Interactive');
      window.performance.measure(
        'Time To Interactive',
        'requestStart',
        'Interactive',
      );
      sendUserTiming('Time To Interactive');
    }
  });
}

export default recordPerformanceMetrics;
